import { render, staticRenderFns } from "./IqcReturn.vue?vue&type=template&id=514139d5"
import script from "./IqcReturn.vue?vue&type=script&lang=js"
export * from "./IqcReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports